export default __webpack_public_path__ + "static/media/about_us_banner.ca7e0279.png";